var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _path212, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93, _text94, _text95, _text96, _text97, _text98, _text99, _text100, _text101, _text102, _text103, _text104, _text105, _text106, _text107, _text108, _text109, _text110, _text111, _text112, _text113, _text114, _text115, _text116, _text117, _text118, _text119, _text120, _text121, _text122, _text123, _text124, _text125, _text126, _text127, _text128, _text129, _text130, _text131, _text132, _text133, _text134, _text135, _text136, _text137, _text138, _text139, _text140, _text141, _text142, _text143, _text144, _text145, _text146, _text147, _text148, _text149, _text150, _text151, _text152, _text153, _text154, _text155, _text156, _text157, _text158, _text159, _text160, _text161, _text162, _text163, _text164, _text165, _text166, _text167;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrp5SpeedscaleLow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "8bb072c8-a3fd-4354-a016-6b6b4c86a70a",
    "data-name": "Card 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.2 840.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crp5_11{fill:#fff}.crp5_31,.crp5_18,.crp5_17,.crp5_32{fill:none;stroke-miterlimit:10}.crp5_18,.crp5_17{stroke:#000}.crp5_18{stroke-width:0.5px}.crp5_24,.crp5_31,.crp5_32{font-size:9.76px}.crp5_24,.crp5_28{fill:#1d1d1b}.crp5_24,.crp5_31,.crp5_32,.crp5_28{font-family:HelveticaNeue-Condensed, Helvetica Neue}.crp5_28{font-size:6.82px}.crp5_31,.crp5_32{stroke:#fff}.crp5_31{stroke-width:2.5px}.crp5_32{stroke-width:3px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "crp5_11",
    x: 131.79,
    y: 62.59,
    width: 327.21,
    height: 715.83,
    rx: 25.23,
    ry: 25.23
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "crp5_18",
    x: 131.79,
    y: 62.59,
    width: 327.21,
    height: 715.83,
    rx: 25.23,
    ry: 25.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 92.67s64.53-17.25 149.14-17.25c0 0 77.61 0 148.11 17.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 97.67s64.53-17.25 149.14-17.25c0 0 77.61 0 148.11 17.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 101.67s64.53-17.25 149.14-17.25c0 0 77.61 0 148.11 17.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 105.67s64.53-16.62 149.14-16.62c0 0 77.61 0 148.11 16.62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 110.09s64.53-16.63 149.14-16.63c0 0 77.61 0 148.11 16.63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 114.67s64.53-17 149.14-17c0 0 77.61 0 148.11 17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 119.67s64.53-18 149.14-18c0 0 77.61 0 148.11 18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 125.05s64.53-18.88 149.14-18.88c0 0 77.61 0 148.11 18.88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 129.36s64.53-19.06 149.14-19.06c0 0 77.61 0 148.11 19.06"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 133.36s64.53-19 149.14-19c0 0 77.61 0 148.11 19"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 138.85s64.53-19.68 149.14-19.68c0 0 77.61 0 148.11 19.68"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 143.24s64.53-20.07 149.14-20.07c0 0 77.61 0 148.11 20.07"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 147.11s64.53-19.94 149.14-19.94c0 0 77.61 0 148.11 19.94"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 151.42s64.53-20.25 149.14-20.25c0 0 77.61 0 148.11 20.25"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 155.42s64.53-20.12 149.14-20.12c0 0 77.61 0 148.11 20.12"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 160.14s64.53-21.29 149.14-21.29c0 0 77.61 0 148.11 21.29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 164.24s64.53-21 149.14-21c0 0 77.61 0 148.11 21"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 168.62s64.53-21 149.14-21c0 0 77.61 0 148.11 21"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 172.65s64.53-21.54 149.14-21.54c0 0 77.61 0 148.11 21.54"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 176.63s64.53-21.21 149.14-21.21c0 0 77.61 0 148.11 21.21"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 181.14s64.53-22.09 149.14-22.09c0 0 77.61 0 148.11 22.09"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 185.24s64.53-21.82 149.14-21.82c0 0 77.61 0 148.11 21.82"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 189.62s64.53-22.2 149.14-22.2c0 0 77.61 0 148.11 22.2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 193.65s64.53-22.39 149.14-22.39c0 0 77.61 0 148.11 22.39"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 197.63s64.53-22 149.14-22c0 0 77.61 0 148.11 22"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 202.14s64.53-22.47 149.14-22.47c0 0 77.61 0 148.11 22.47"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 206.24s64.53-22.81 149.14-22.81c0 0 77.61 0 148.11 22.81"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 210.62s64.53-23 149.14-23c0 0 77.61 0 148.11 23"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 214.65s64.53-22.39 149.14-22.39c0 0 77.61 0 148.11 22.39"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 218.63s64.53-23 149.14-23c0 0 77.61 0 148.11 23"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 223.14s64.53-23.21 149.14-23.21c0 0 77.61 0 148.11 23.21"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 227.24s64.53-23.5 149.14-23.5c0 0 77.61 0 148.11 23.5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 231.62s64.53-24.07 149.14-24.07c0 0 77.61 0 148.11 24.07"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 235.65s64.53-24.12 149.14-24.12c0 0 77.61 0 148.11 24.12"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 239.63S210.83 216 295.44 216c0 0 77.61 0 148.11 23.64"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 244.14s64.53-24.09 149.14-24.09c0 0 77.61 0 148.11 24.09"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 248.24s64.53-24.65 149.14-24.65c0 0 77.61 0 148.11 24.65"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 252.62s64.53-24.81 149.14-24.81c0 0 77.61 0 148.11 24.81"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 256.65s64.53-25 149.14-25c0 0 77.61 0 148.11 25"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 261.24s64.53-25.32 149.14-25.32c0 0 77.61 0 148.11 25.32"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 265.76s64.53-26.13 149.14-26.13c0 0 77.61 0 148.11 26.13"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 270.24s64.53-26.69 149.14-26.69c0 0 77.61 0 148.11 26.69"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 274.21s64.53-26.54 149.14-26.54c0 0 77.61 0 148.11 26.54"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 278.24s64.53-26.44 149.14-26.44c0 0 77.61 0 148.11 26.44"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 282.83s64.53-27.16 149.14-27.16c0 0 77.61 0 148.11 27.16"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 286.74s64.53-27.07 149.14-27.07c0 0 77.61 0 148.11 27.07"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 291.24s64.53-26.69 149.14-26.69c0 0 77.41-1 148.11 26.69"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 295.78s64.53-27.86 149.14-27.86c0 0 77.61 0 148.11 27.86"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 300s64.53-28 149.14-28c0 0 77.61 0 148.11 28"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 304.41s64.53-28 149.14-28c0 0 77.27-2.21 148.11 28"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 308.32s64.53-28.52 149.14-28.52c0 0 77.61 0 148.11 28.52"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 313.13s64.53-29.08 149.14-29.08c0 0 77.61 0 148.11 29.08"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 317.67s64.53-29.62 149.14-29.62c0 0 77.61 0 148.11 29.62"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 321.84s64.53-29.79 149.14-29.79c0 0 77.61 0 148.11 29.79"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 326.29s64.53-29.87 149.14-29.87c0 0 77.52-2.36 148.11 29.87"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 330.2s64.53-29.65 149.14-29.65c0 0 77.61 0 148.11 29.65"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 335.13s64.53-30.72 149.14-30.72c0 0 77.27-1.55 148.11 30.72"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 339.67s64.53-31.35 149.14-31.35c0 0 77.77-1.37 148.11 31.35"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 343.84s64.53-31.54 149.14-31.54c0 0 77-.94 148.11 31.54"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 348.29s64.53-31.87 149.14-31.87c0 0 77.27-1.05 148.11 31.87"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 352.2s64.53-31.9 149.14-31.9c0 0 77.61 0 148.11 31.9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 356.9S210.83 324 295.44 324c0 0 77.61 0 148.11 32.91"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 361.44s64.53-32.77 149.14-32.77c0 0 77.52-2.38 148.11 32.77"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 365.61s64.53-33.25 149.14-33.25c0 0 77.61 0 148.11 33.25"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 370.06s64.53-33.81 149.14-33.81c0 0 77.61 0 148.11 33.81"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 375s64.53-34.57 149.14-34.57c0 0 74-.77 148.11 34.57"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 378.9s64.53-34.35 149.14-34.35c0 0 77.77-.71 148.11 34.35"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 383.44S210.83 349 295.44 349c0 0 75.52-1.81 148.11 34.46"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 388.14s64.53-35 149.14-35c0 0 78-.95 148.11 35"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 392.68s64.53-35.78 149.14-35.78c0 0 76.71-2.56 148.11 35.78"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 397.47s64.53-36.55 149.14-36.55c0 0 77.43-1.95 148.11 36.55"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 401.9s64.53-36.85 149.14-36.85c0 0 77.65-1.7 148.11 36.85"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 406.44s64.53-37.64 149.14-37.64c0 0 76.67-1.71 148.11 37.64"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 411.14s64.53-37.72 149.14-37.72c0 0 77.61-1 148.11 36.72"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 415.68s64.53-38.38 149.14-38.38c0 0 77.61-1 148.11 37.38"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 420.13s64.53-39.08 149.14-39.08c0 0 77.61-1 148.11 38.08"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 424.9s64.53-39.6 149.14-39.6c0 0 76.8-1.83 148.11 38.6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 429.44s64.53-40 149.14-40c0 0 77.61-1 148.11 39"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 434.14s64.53-40.72 149.14-40.72c0 0 78.52-1.14 148.11 39.72"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 439.32s64.53-41.85 149.14-41.85c0 0 76.95-1.55 148.11 40.85"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 443.13s64.53-41.83 149.14-41.83c0 0 77-2.63 148.11 41.83"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 447.9s64.53-42.23 149.14-42.23c0 0 75.27-3.77 148.11 42.23"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 453.44s64.53-44 149.14-44c0 0 75.52-3 148.11 43"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 458.38s64.53-45.21 149.14-45.21c0 0 77.61-1 148.11 44.21"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 462.77s64.53-45.35 149.14-45.35c0 0 77.52-1.74 148.11 44.35"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 467.86s64.53-46.19 149.14-46.19c0 0 76.77-3.28 148.11 45.19"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 472.9s64.53-47.1 149.14-47.1c0 0 77.27-2.38 148.11 46.1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 477.44s64.53-48 149.14-48c0 0 77.61-1 148.11 47"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 482.38s64.53-49 149.14-49c0 0 77.61-1 148.11 48"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 487.77s64.53-49.85 149.14-49.85c0 0 77.27-2.14 148.11 48.85"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 492.86s64.53-51.19 149.14-51.19c0 0 77.61-1 148.11 50.19"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 497.9s64.53-52.35 149.14-52.35c0 0 77.61-2 148.11 50.35"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 502.44s64.53-52.52 149.14-52.52c0 0 78.05-2.83 148.11 51.52"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 508.38s64.53-54.58 149.14-54.58c0 0 77.44-2.61 148.11 53.58"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 514.17S205.09 457.9 295 457.9s148.6 55.27 148.6 55.27"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 519.17s58.79-57.5 148.65-57.5 148.6 56.5 148.6 56.5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 525.17s58.79-59.24 148.7-59.24 148.6 58.24 148.6 58.24"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 530.17s58.79-60.74 148.7-60.74 148.6 59.74 148.6 59.74"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 535.17s58.79-61.41 148.7-61.41c92.1 0 148.6 61.41 148.6 61.41"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 542.17s58.79-64.08 148.7-64.08c92.79 0 148.6 62.08 148.6 62.08"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 548.17s58.79-66.41 148.7-66.41c94.76 0 148.6 65.41 148.6 65.41"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 554.17s59.7-69.64 149.61-68.91c96.22.78 147.64 67.91 147.64 67.91"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 560.76s54.33-71.59 149.61-71.59 147.64 69.59 147.64 69.59"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 566.76s54.33-73.09 149.61-73.09 147.64 71.09 147.64 71.09"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.3 572.76s54.33-74.86 149.61-74.86 147.64 73.86 147.64 73.86"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M146.3 579.76s54.33-78 149.61-78 147.64 76 147.64 76"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.28 587.42s51-81.75 149.63-81.75 147.65 79.75 147.65 79.75"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.28 594.42s51-84.29 149.63-84.29 147.65 82.29 147.65 82.29"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M443.55 601.42s-42.11-87.25-147.64-87.25-149.61 89.25-149.61 89.25"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M146.31 613.17s40.74-95 149.6-95 147.63 92 147.63 92"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M151.25 613.17s39.41-90.93 144.66-90.93 144.68 90.93 144.68 90.93"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M155.59 613.17s38.25-86.42 140.32-86.42 140.35 86.42 140.35 86.42"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M160.66 613.17s36.89-82.95 135.25-82.95 136.28 82.95 136.28 82.95"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M165.32 613.17s35.68-79.41 130.59-79.41 130.77 79.63 130.77 79.63"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M169.61 613.17s34.5-74.87 126.3-74.87 126.33 74.87 126.33 74.87"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M174.3 613.17s36-71 121.61-71 121.64 71 121.64 71"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M179.05 613.17s37-66.62 116.86-66.62 116.89 66.62 116.89 66.62"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M183.05 613.17s36.54-62.5 112.86-62.5 112.89 62.5 112.89 62.5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M187.67 613.17s35.88-59 108.24-59 107.26 59 107.26 59"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M193.05 613.17s34-54.37 102.86-54.37 102.89 54.37 102.89 54.37"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M197.67 613.17s35.24-51 98.24-51 98.26 51 98.26 51"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M202.05 613.17s32.44-46.41 93.86-46.41 92.89 46.41 92.89 46.41"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M206.8 613.17S237.71 571 295.91 571c58.77 0 88.14 42.21 88.14 42.21"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M212.55 613.17s30.57-38.5 83.36-38.5 82.39 38.5 82.39 38.5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M218.21 613.17s29-34.5 77.21-34.5 77.58 34.5 77.58 34.5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M223.71 613.17s26.93-30.5 72.21-30.5c0 0 39.54-1.75 71.79 30.5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M229.71 613.17s25.73-26.75 65.71-26.75c0 0 37.79-.75 66.54 26.75"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M235.21 613.17S255 591 295.42 591c0 0 32-1.3 60.79 22.2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M242 613.17s21.14-17.75 53.46-17.75c0 0 24-3 54 17.75"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M249 613.17s16.43-14.37 47-14.37c0 0 27.79.37 47 14.37"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M257 613.17s14.5-9.75 38.75-9.75 39.75 9.75 39.75 9.75M295.44 75.42v528M241.95 77.65l36.34 404.73M281.97 604.51L189.14 84.05M146.3 127.17l96.9 362M268.45 607.87L146.46 274.39M146.28 363.09l64.22 138.67M254.96 613.17L146.28 425.2M146.28 469.43l34.31 49.74M236.96 613.17l-90.68-108.5M146.28 533.76l7.39 7M146.28 557.09l66.15 55.9M146.3 597.92l27.66 15.07M347.69 77.65l-34.48 404.73M309.58 604.51L400.5 84.05M443.34 128.16l-95.65 360.42M323.46 607.54l120.09-331.15M443.71 366.2l-62.79 134.85M335.46 613.17l108.25-186.42M443.71 472.49l-32.72 46.14M354.49 613.17l88.87-105.25M443.65 535.33l-5.73 5.43M443.36 559.55l-63.21 53.62M443.34 598.8l-25.79 14.37"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M284.96 75.42l7 406.34M273.96 75.79l18.83 527.63M290.46 603.58L252.61 76.86M284.96 482.38L263.05 76.25M231.61 78.57l55.84 525.24M284.79 604.22L210.32 80.98M220.97 79.69l50.57 403.58M264.28 484.35L199.79 82.42M179.23 85.73l77.73 400.31M279.3 604.97L168.55 87.73M158.05 89.9l92.6 397.28M276.59 605.55L147.45 92.38M146.46 163.42l127.5 442.77M271.54 606.87L146.3 224.59M146.3 196.42l90.66 294.67M230.63 492.86L146.3 250.09M151.13 306.95l72.8 188.87M265.62 608.92L146.3 312.3M146.46 331.26l70.84 167.35M263.14 609.95L146.28 347.59M146.3 376.59l114.54 234.43M258.09 612.49L146.28 402.27M146.28 390.26l58.43 114.4M146.3 413.78l52.46 94.1M146.3 434.93l45.75 76.25M146.28 444.1l106.33 169.07M146.3 452.59l40.63 62.38M146.28 461.67l102.28 151.5M244.96 613.17l-98.68-135.4M146.3 484.35l28.58 38.87M146.28 491.93l94.68 121.24M232.29 613.17l-85.99-96.08M146.3 511.18l17.81 20.4M146.3 498.61l23.31 28.57M146.46 523.22l12.24 12.96M146.28 528.64l81.85 84.53M146.46 539.09l77 74.08M146.28 543.93l2.22 1.9M146.46 548.93l71.5 64.24M146.46 565.67l59.5 47.5M146.28 574.67l53.17 38.5M146.28 582.66l45.34 30.51M146.28 589.97l38.01 23.2M146.3 604.22l17.14 8.95M146.28 609.95l5.3 3.22M427.4 613.39l16.14-8.88M443.71 611.3l-3.69 1.87M443.71 590.95l-36 22.22M443.71 583.67l-44.4 29.5M443.71 575.74l-51.25 37.43M443.71 567.71l-57.62 45.46M443.71 549.55l-69.12 63.62M368.46 613.17l75.25-72.75M443.71 530.22l-79.75 82.95M359.21 613.17l84.33-94M432.9 536.24l10.81-11.27M427.95 531.81l15.76-18.14M443.71 500.8l-21.47 26.25M443.71 493.67l-93.25 119.5M346.55 613.17l97.16-134M416.68 522.74l26.87-35.97M443.71 463.42L342.96 613.17M339.63 613.17l103.93-167.12M443.71 455.05l-38.68 59.58M398.92 510.81l44.79-74.14M392.83 507.29l49.38-88.9M386.77 504.05l56.78-111.37M374.34 497.9l69.37-163.35M443.71 296.39l-76.24 198.96M361.22 493.03l82.49-242.11M443.71 195.59l-89.48 295.13M340.69 487.03l91.09-397.07M411.35 85.97l-77.51 399.57M326.8 484.28L389.97 82.6M368.95 79.99l-48.76 403.35M305.95 482.06L326.8 76.5M305.46 75.42l-6.37 406.38M298.21 603.42l18.17-527.44M336.96 77.14l-36.03 526.44M304 603.81L358.38 78.9M379.46 81.22l-72.94 522.59M420.86 87.73L312.28 604.97M315.04 605.55L442.33 92.38M443.71 315.37L325.82 608.71M320.23 606.87l123.32-381.2M443.71 163.42L317.74 606.19M328.39 609.72l115.17-258.96M443.34 381.05L331.19 610.94M333.65 612.16l110.06-207.17"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M443.21 613.49v160.1h-296.4v-160.1h296.4m.5-.5h-297.4v161.1h297.4V613z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M154.87 613.17v160.92M174.87 613.17v160.92M194.87 613.17v160.92M214.87 613.17v160.92M235.87 613.17v160.92M255.87 613.17v160.92M275.87 613.17v160.92M295.87 613.17v160.92M315.87 613.17v160.92M335.87 613.17v160.92M355.87 613.17v160.92M375.87 613.17v160.92M396.87 613.17v160.92M416.87 613.17v160.92M436.87 613.17v160.92M146.28 713.13h297.06M146.28 693.13h297.06M146.28 673.13h297.06M146.28 653.13h297.06M146.28 633.13h297.06M146.28 754.13h297.06M146.28 733.13h297.06"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M158.87 613.17v160.92M178.87 613.17v160.92M198.87 613.17v160.92M218.87 613.17v160.92M239.87 613.17v160.92M259.87 613.17v160.92M279.87 613.17v160.92M299.87 613.17v160.92M319.87 613.17v160.92M339.87 613.17v160.92M162.87 613.17v160.92M182.87 613.17v160.92M202.87 613.17v160.92M222.87 613.17v160.92M243.87 613.17v160.92M263.87 613.17v160.92M283.87 613.17v160.92M303.87 613.17v160.92M323.87 613.17v160.92M343.87 613.17v160.92M166.87 613.17v160.92M186.87 613.17v160.92M206.87 613.17v160.92M226.87 613.17v160.92M247.87 613.17v160.92M267.87 613.17v160.92M287.87 613.17v160.92M307.87 613.17v160.92M327.87 613.17v160.92M347.87 613.17v160.92M170.87 613.17v160.92M190.87 613.17v160.92M210.87 613.17v160.92M230.87 613.17v160.92M251.87 613.17v160.92M271.87 613.17v160.92M291.87 613.17v160.92M311.87 613.17v160.92M331.87 613.17v160.92M351.87 613.17v160.92M150.87 613.17v160.92M359.87 613.17v160.92M363.87 613.17v160.92M367.87 613.17v160.92M371.87 613.17v160.92M380.71 613.17v160.92M384.71 613.17v160.92M388.71 613.17v160.92M392.71 613.17v160.92M400.71 613.17v160.92M404.71 613.17v160.92M408.71 613.17v160.92M412.71 613.17v160.92M420.71 613.17v160.92M424.71 613.17v160.92M428.71 613.17v160.92M432.71 613.17v160.92M440.71 613.17v160.92M443.67 617.17H146.41M443.67 621.17H146.41M443.67 625.17H146.41M443.67 629.17H146.41M443.67 637.17H146.41M443.67 641.17H146.41M443.67 645.17H146.41M443.67 649.17H146.41M443.67 657.17H146.41M443.67 661.17H146.41M443.67 665.17H146.41M443.67 669.17H146.41M443.67 677.17H146.41M443.67 681.17H146.41M443.67 685.17H146.41M443.67 689.17H146.41M443.67 697.17H146.41M443.67 701.17H146.41M443.67 705.17H146.41M443.67 709.17H146.41M443.67 717.17H146.41M443.67 721.17H146.41M443.67 725.17H146.41M443.67 729.17H146.41M443.67 737.17H146.41M443.67 741.17H146.41M443.67 745.17H146.41M443.67 749.17H146.41M443.67 758.17H146.41M443.67 762.17H146.41M443.67 766.17H146.41M443.67 770.17H146.41M453.27 756.92h5.38M453.27 754.04h5.74M453.27 751.15h5.74M453.27 748.27h5.74M453.27 745.38h5.74M453.27 742.5h5.74"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 739.61h7.49"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 725.41h5.74M453.27 722.53h5.74M453.27 719.64h5.74M453.27 716.76h5.74M453.27 713.87h5.74"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 711.3h7.49"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 736.86h5.74M453.27 733.98h5.74M453.27 731.09h5.74M453.27 728.21h5.74M453.27 696.73h5.74M453.27 693.84h5.74M453.27 690.96h5.74M453.27 688.07h5.74M453.27 685.19h5.74"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 682.61h7.49"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 708.17h5.74M453.27 705.29h5.74M453.27 702.4h5.74M453.27 699.52h5.74M453.27 668.41h5.74M453.27 665.53h5.74M453.27 662.64h5.74M453.27 659.76h5.74M453.27 656.87h5.74"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 654.3h7.49"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 679.86h5.74M453.27 676.98h5.74M453.27 674.09h5.74M453.27 671.21h5.74M453.27 639.73h5.74M453.27 636.84h5.74M453.27 633.96h5.74M453.27 631.07h5.74M453.27 628.19h5.74"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 625.61h7.49"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 651.17h5.74M453.27 648.29h5.74M453.27 645.4h5.74M453.27 642.52h5.74M453.27 610.95h5.74M453.27 608.07h5.74M453.27 605.18h5.74M453.27 602.29h5.74M453.27 599.41h5.74"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 596.84h7.49"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 622.4h5.74M453.27 619.51h5.74M453.27 616.63h5.74M453.27 613.74h5.74M453.27 582.26h5.74M453.27 579.38h5.74M453.27 576.49h5.74M453.27 573.61h5.74M453.27 570.72h5.74"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 568.15h7.49"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 593.71h5.74M453.27 590.83h5.74M453.27 587.94h5.74M453.27 585.05h5.74M453.27 553.95h5.74M453.27 551.07h5.74M453.27 548.18h5.74M453.27 545.29h5.74M453.27 542.41h5.74"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 539.84h7.49"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 565.4h5.74M453.27 562.51h5.74M453.27 559.63h5.74M453.27 556.74h5.74M453.27 525.26h5.74M453.27 522.38h5.74M453.27 519.49h5.74M453.27 516.61h5.74M453.27 513.72h5.74"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 511.15h7.49"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 536.71h5.74M453.27 533.83h5.74M453.27 530.94h5.74M453.27 528.05h5.74M453.27 496.95h5.74M453.27 494.07h5.74M453.27 491.18h5.74M453.27 488.29h5.74M453.27 485.41h5.74"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 482.84h7.49"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 508.4h5.74M453.27 505.51h5.74M453.27 502.63h5.74M453.27 499.74h5.74M453.27 468.04h5.74M453.27 465.16h5.74M453.27 462.27h5.74M453.27 459.38h5.74M453.27 456.5h5.74"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 453.93h7.49"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 479.49h5.74M453.27 476.6h5.74M453.27 473.72h5.74M453.27 470.83h5.74M453.27 439.07h5.74M453.27 436.18h5.74M453.27 433.3h5.74M453.27 430.41h5.74M453.27 427.53h5.74"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 424.95h7.49"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 450.52h5.74M453.27 447.63h5.74M453.27 444.75h5.74M453.27 441.86h5.74M453.27 410.6h5.74M453.27 407.72h5.74M453.27 404.83h5.74M453.27 401.95h5.74M453.27 399.06h5.74"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 396.49h7.49"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 422.05h5.74M453.27 419.17h5.74M453.27 416.28h5.74M453.27 413.39h5.74M453.27 382.07h5.74M453.27 379.18h5.74M453.27 376.3h5.74M453.27 373.41h5.74M453.27 370.53h5.74"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 367.95h7.49"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 393.52h5.74M453.27 390.63h5.74M453.27 387.75h5.74M453.27 384.86h5.74M453.27 353.6h5.74M453.27 350.72h5.74M453.27 347.83h5.74M453.27 344.95h5.74M453.27 342.06h5.74"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 339.49h7.49"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 365.05h5.74M453.27 362.17h5.74M453.27 359.28h5.74M453.27 356.39h5.74M453.27 325.07h5.74M453.27 322.18h5.74M453.27 319.3h5.74M453.27 316.41h5.74M453.27 313.53h5.74"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 310.95h7.49"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 336.52h5.74M453.27 333.63h5.74M453.27 330.75h5.74M453.27 327.86h5.74M453.27 296.6h5.74M453.27 293.72h5.74M453.27 290.83h5.74M453.27 287.95h5.74M453.27 285.06h5.74"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 282.49h7.49"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 308.05h5.74M453.27 305.17h5.74M453.27 302.28h5.74M453.27 299.39h5.74M453.27 267.91h5.74M453.27 264.99h5.74M453.27 262.06h5.74M453.27 259.14h5.74M453.27 256.22h5.74"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 253.61h7.49"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 279.52h5.74M453.27 276.59h5.74M453.27 273.67h5.74M453.27 270.74h5.74M453.27 239.06h5.74M453.27 236.14h5.74M453.27 233.21h5.74M453.27 230.29h5.74M453.27 227.37h5.74"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 224.76h7.49"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 250.67h5.74M453.27 247.74h5.74M453.27 244.82h5.74M453.27 241.89h5.74M453.27 210.61h5.74M453.27 207.69h5.74M453.27 204.76h5.74M453.27 201.84h5.74M453.27 198.91h5.74"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 196.31h7.49"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 222.21h5.74M453.27 219.29h5.74M453.27 216.37h5.74M453.27 213.44h5.74M453.27 181.76h5.74M453.27 178.84h5.74M453.27 175.91h5.74M453.27 172.99h5.74M453.27 170.06h5.74"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 167.46h7.49"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 193.36h5.74M453.27 190.44h5.74M453.27 187.52h5.74M453.27 184.59h5.74M453.27 153.03h5.74M453.27 150.14h5.74M453.27 147.24h5.74M453.27 144.35h5.74M453.27 141.45h5.74"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 138.87h7.49"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 164.52h5.74M453.27 161.63h5.74M453.27 158.73h5.74M453.27 155.83h5.74M453.27 124.46h5.74M453.27 121.57h5.74M453.27 118.67h5.74M453.27 115.78h5.74M453.27 112.88h5.74"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 110.3h7.49"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 135.95h5.74M453.27 133.06h5.74M453.27 130.16h5.74M453.27 127.27h5.74M453.27 95.91h5.74M453.27 92.98h5.74M453.27 90.04h5.74M453.27 87.1h5.74M453.27 84.17h5.55"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M451.52 81.55h6.82"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M453.27 107.56h5.74M453.27 104.62h5.74M453.27 101.69h5.74M453.27 98.75h5.74M132.84 90.92h4.5M132.84 101.67h4.5"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 112.09h4.5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 143.92h4.5M132.84 154.67h4.5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 165.09h5.12"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 122.92h4.5M132.84 133.67h4.5M132.84 197.13h4.5M132.84 207.88h4.5"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 218.3h5.12"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 176.13h4.5M132.84 186.88h4.5M132.84 250.44h4.5M132.84 261.35h4.5"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 271.92h5.12"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 229.13h4.5M132.84 239.63h4.5M132.84 303.44h4.5M132.84 314.35h4.5"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 324.92h5.12"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 282.13h4.5M132.84 292.63h4.5M132.84 356.9h4.5M132.84 367.65h4.5"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 378.42h5.12"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 335.67h4.5M132.84 346.35h4.5M132.84 409.56h4.5M132.84 420.47h4.5"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 431.41h5.12"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 388.25h4.5M132.84 398.75h4.5M132.84 463.56h4.5M132.84 473.47h4.5"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 484.04h5.12"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 442.25h4.5M132.84 452.75h4.5M132.84 517.1h4.5M132.84 527.23h4.5"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 538.04h5.12"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 495.3h4.5M132.84 506.04h4.5M132.84 570.1h4.5M132.84 580.23h4.5"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 591.04h5.12"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 548.3h4.5M132.84 559.04h4.5M132.84 570.1h4.5M132.84 580.23h4.5"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 591.04h5.12"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 548.3h4.5M132.84 559.04h4.5M132.84 623.1h4.5M132.84 633.23h4.5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.84 644.04h5.12"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 601.3h4.5M132.84 612.04h4.5M132.84 676.1h4.5M132.84 686.23h4.5"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.89 697.43h5.13"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 654.3h4.5M132.84 665.04h4.5M132.84 729.11h4.5M132.84 739h4.5"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_17",
    d: "M132.89 749.92h5.13"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_18",
    d: "M132.84 707.84h4.5M132.84 718.32h4.5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(145.29 116.96) rotate(-90)"
  }, "60")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(145.29 223.14) rotate(-90)"
  }, "50")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(145.29 329.51) rotate(-90)"
  }, "40")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(145.29 435.78) rotate(-90)"
  }, "30")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(145.29 542.78) rotate(-90)"
  }, "20")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(145.29 648.78) rotate(-90)"
  }, "10")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(145.69 719.28) rotate(-90)",
    fontSize: 7.89,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#1d1d1b"
  }, "nm l:500 000")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(145.29 752.44) rotate(-90)"
  }, "0")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(433.45 75.98)"
  }, "L")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 79.99) rotate(90)"
  }, "0mm")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 107.25) rotate(90)"
  }, "10")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 135.58) rotate(90)"
  }, "20")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 164.41) rotate(90)"
  }, "30")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 222.14) rotate(90)"
  }, "50")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 250.67) rotate(90)"
  }, "60")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 193.14) rotate(90)"
  }, "40")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 279.52) rotate(90)"
  }, "70")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 307.52) rotate(90)"
  }, "80")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 336.52) rotate(90)"
  }, "90")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 362.52) rotate(90)"
  }, "100")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 391.52) rotate(90)"
  }, "110")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 420.52) rotate(90)"
  }, "120")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 449.52) rotate(90)"
  }, "130")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 478.09) rotate(90)"
  }, "140")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 505.67) rotate(90)"
  }, "150")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 534.67) rotate(90)"
  }, "160")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 563.67) rotate(90)"
  }, "170")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 591.67) rotate(90)"
  }, "180")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 620.67) rotate(90)"
  }, "190")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 649.67) rotate(90)"
  }, "200")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 677.67) rotate(90)"
  }, "210")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 706.67) rotate(90)"
  }, "220")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_28",
    transform: "translate(445.02 734.67) rotate(90)"
  }, "230")), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_11",
    d: "M287.45 149.16h15.89v9.07h-15.89zM287.45 169.16h15.89v9.07h-15.89z"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 73.18)"
  }, "300")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 95.18)"
  }, "290")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 116.18)"
  }, "280")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 136.18)"
  }, "270")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 157.18)"
  }, "260")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 197.18)"
  }, "240")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 177.18)"
  }, "250")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 218.18)"
  }, "230")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 237.18)"
  }, "220")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 257.18)"
  }, "210")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 278.18)"
  }, "200")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 298.18)"
  }, "190")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 318.18)"
  }, "180")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 338.18)"
  }, "170")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 359.18)"
  }, "160")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 378.18)"
  }, "150")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 399.18)"
  }, "140")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 419.18)"
  }, "130")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 439.18)"
  }, "120")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 460.18)"
  }, "110")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(288.57 479.18)"
  }, "100")), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 500.18)"
  }, "90")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 520.18)"
  }, "80")), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 540.18)"
  }, "70")), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 560.18)"
  }, "60")), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 580.18)"
  }, "50")), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 600.18)"
  }, "40")), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 631.18)"
  }, "10")), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 651.18)"
  }, "20")), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 671.18)"
  }, "30")), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 691.18)"
  }, "40")), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 711.18)"
  }, "50")), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 731.18)"
  }, "60")), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 751.18)"
  }, "70")), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_31",
    transform: "translate(290.91 771.18)"
  }, "80")), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 73.18)"
  }, "300")), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 95.18)"
  }, "290")), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 116.18)"
  }, "280")), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 136.18)"
  }, "270")), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 157.18)"
  }, "260")), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 197.18)"
  }, "240")), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 177.18)"
  }, "250")), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 218.18)"
  }, "230")), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 237.18)"
  }, "220")), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 257.18)"
  }, "210")), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 278.18)"
  }, "200")), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 298.18)"
  }, "190")), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 318.18)"
  }, "180")), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 338.18)"
  }, "170")), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 359.18)"
  }, "160")), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 378.18)"
  }, "150")), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 399.18)"
  }, "140")), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 419.18)"
  }, "130")), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 439.18)"
  }, "120")), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 460.18)"
  }, "110")), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(288.57 479.18)"
  }, "100")), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 500.18)"
  }, "90")), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 520.18)"
  }, "80")), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 540.18)"
  }, "70")), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 560.18)"
  }, "60")), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 580.18)"
  }, "50")), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 600.18)"
  }, "40")), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 631.18)"
  }, "10")), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 651.18)"
  }, "20")), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 671.18)"
  }, "30")), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 691.18)"
  }, "40")), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 711.18)"
  }, "50")), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 731.18)"
  }, "60")), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 751.18)"
  }, "70")), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(290.91 771.18)"
  }, "80")), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(219.89 282.98) rotate(-9.93)"
  }, "10")), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(185.38 290.32) rotate(-12.69)"
  }, "15")), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 151.41, 301.54)"
  }, "20")), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(257.76 277.43) rotate(-5.32)"
  }, "5")), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(201.72 183.11) rotate(-9.93)"
  }, "10")), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(159.87 196.03) rotate(-14.73)"
  }, "15")), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(248.29 176.83) rotate(-5.32)"
  }, "5")), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(237.37 383.48) rotate(-9.93)"
  }, "10")), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(212.13 389.36) rotate(-14.32)"
  }, "15")), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 187.22, 397.21)"
  }, "20")), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(266.76 379.43) rotate(-5.32)"
  }, "5")), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(161.37 407.3) rotate(-21.96)"
  }, "25")), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 221.18, 492.67)"
  }, "20")), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(255.1 481.93) rotate(-10.48)"
  }, "10")), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(189.09 508.48) rotate(-28.31)"
  }, "30")), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(0.78, -0.62, 0.62, 0.78, 160.45, 528.96)"
  }, "40")), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(362.15 489.09) rotate(20.09)"
  }, "20")), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(394.42 503.19) rotate(29.31)"
  }, "30")), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(424.3 523.03) rotate(39.64)"
  }, "40")), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(326.52 480.32) rotate(9.3)"
  }, "10")), _text124 || (_text124 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(396.24 394.41) rotate(15.47)"
  }, "20")), _text125 || (_text125 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(421.17 403.74) rotate(22.39)"
  }, "25")), _text126 || (_text126 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(369.75 386.76) rotate(12.05)"
  }, "15")), _text127 || (_text127 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(344.02 381.87) rotate(9.3)"
  }, "10")), _text128 || (_text128 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(1, 0.06, -0.06, 1, 320.19, 378.75)"
  }, "5")), _text129 || (_text129 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(0.93, 0.35, -0.35, 0.93, 430.25, 298.9)"
  }, "20")), _text130 || (_text130 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(395.82 288.04) rotate(15.87)"
  }, "15")), _text131 || (_text131 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(360.99 281.37) rotate(9.3)"
  }, "10")), _text132 || (_text132 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(1, 0.06, -0.06, 1, 328.17, 277.39)"
  }, "5")), _text133 || (_text133 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(421.95 191.01) rotate(15.87)"
  }, "15")), _text134 || (_text134 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "translate(378.45 182.66) rotate(9.3)"
  }, "10")), _text135 || (_text135 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_32",
    transform: "matrix(1, 0.06, -0.06, 1, 337.13, 177.4)"
  }, "5")), _text136 || (_text136 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(219.89 282.98) rotate(-9.93)"
  }, "10")), _text137 || (_text137 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(185.38 290.32) rotate(-12.69)"
  }, "15")), _text138 || (_text138 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 151.41, 301.54)"
  }, "20")), _text139 || (_text139 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(257.76 277.43) rotate(-5.32)"
  }, "5")), _text140 || (_text140 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(201.72 183.11) rotate(-9.93)"
  }, "10")), _text141 || (_text141 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(159.87 196.03) rotate(-14.73)"
  }, "15")), _text142 || (_text142 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(248.29 176.83) rotate(-5.32)"
  }, "5")), _text143 || (_text143 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(237.37 383.48) rotate(-9.93)"
  }, "10")), _text144 || (_text144 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(212.13 389.36) rotate(-14.32)"
  }, "15")), _text145 || (_text145 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 187.22, 397.21)"
  }, "20")), _text146 || (_text146 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(266.76 379.43) rotate(-5.32)"
  }, "5")), _text147 || (_text147 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(161.37 407.3) rotate(-21.96)"
  }, "25")), _text148 || (_text148 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 221.18, 492.67)"
  }, "20")), _text149 || (_text149 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(255.1 481.93) rotate(-10.48)"
  }, "10")), _text150 || (_text150 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(189.09 508.48) rotate(-28.31)"
  }, "30")), _text151 || (_text151 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(0.78, -0.62, 0.62, 0.78, 160.45, 528.96)"
  }, "40")), _text152 || (_text152 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(362.15 489.09) rotate(20.09)"
  }, "20")), _text153 || (_text153 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(394.42 503.19) rotate(29.31)"
  }, "30")), _text154 || (_text154 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(424.3 523.03) rotate(39.64)"
  }, "40")), _text155 || (_text155 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(326.52 480.32) rotate(9.3)"
  }, "10")), _text156 || (_text156 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(396.24 394.41) rotate(15.47)"
  }, "20")), _text157 || (_text157 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(421.17 403.74) rotate(22.39)"
  }, "25")), _text158 || (_text158 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(369.75 386.76) rotate(12.05)"
  }, "15")), _text159 || (_text159 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(344.02 381.87) rotate(9.3)"
  }, "10")), _text160 || (_text160 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(1, 0.06, -0.06, 1, 320.19, 378.75)"
  }, "5")), _text161 || (_text161 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(0.93, 0.35, -0.35, 0.93, 430.25, 298.9)"
  }, "20")), _text162 || (_text162 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(395.82 288.04) rotate(15.87)"
  }, "15")), _text163 || (_text163 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(360.99 281.37) rotate(9.3)"
  }, "10")), _text164 || (_text164 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(1, 0.06, -0.06, 1, 328.17, 277.39)"
  }, "5")), _text165 || (_text165 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(421.95 191.01) rotate(15.87)"
  }, "15")), _text166 || (_text166 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "translate(378.45 182.66) rotate(9.3)"
  }, "10")), _text167 || (_text167 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_24",
    transform: "matrix(1, 0.06, -0.06, 1, 337.13, 177.4)"
  }, "5")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp5SpeedscaleLow);
export default __webpack_public_path__ + "static/media/crp5-speedscale-low.bd9b98f39d96ea65c334fb6bd331a8ec.svg";
export { ForwardRef as ReactComponent };